export const SET_PLAYER_CHOICE = "SET_PLAYER_CHOICE";
export const SET_PHASE = "SET_PHASE";
export const PLAY_AGAIN = "PLAY_AGAIN";
